import './DashboardSelector.css';

import { useEffect, useState } from 'react';
import B2BElementsExplorerInMemory from '../../b2b-common/B2BElementsExplorerInMemory';
import DashboardMiniCard from './DashboardMiniCard';
import { arraysAreEqual } from '../../b2b-common/helpers';

const DashboardSelector = ({ dashboards = null, page, setPage, selectedDashboard = null,  onSelectedDashboard }) => {

    const [dashboardsData, setDashboardsData] = useState(dashboards);

    useEffect(() => {
        // console.log('DashboardSelector useEffect');
        if (dashboardsData.content && dashboards.content && !arraysAreEqual(dashboardsData.content, dashboards.content)) {
            setDashboardsData(dashboards);
        }
    }, [dashboards, page, setPage]);

    const handleSelectedDashboard = (dashboard) => {
        // console.log('handleSelectedDashboard:', dashboard);
        // setSelectedDashboard(dashboard);
        onSelectedDashboard && onSelectedDashboard(dashboard);
    }

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // console.log('dashboardsData:', dashboardsData);

    return (
        dashboardsData && dashboardsData.content.length > 0 && (
            <B2BElementsExplorerInMemory
                numRows={4}
                elementsData={dashboardsData}
                onSelectedElement={onSelectedDashboard}
                className='dashboard-selector'
                ElementComponent={DashboardMiniCard}
                elementComponentPropName={'dashboard'}
                otherComponentProps={{
                    selectedDashboard: selectedDashboard,
                }}
                elementComponentHandlers={{
                    onSelect: handleSelectedDashboard
                }}
                currentPage={page}
                handlePageChange={handlePageChange}
            />
        )
    );
};

export default DashboardSelector;